import React, { useState, useRef, useEffect } from "react";
import {
  menuAbout,
  specialClinic,
  menuNew,
  menuContact,
  menuSurgery,
  menuDiagnose,
  menuOther,
} from "../inc/Datamenu_inc";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import { motion, AnimatePresence } from "framer-motion";

const DropdownMenu = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null); // State สำหรับเมนูที่กำลังโฮเวอร์
  const hoverTimeout = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const navigate = useNavigate();

  // const location = useLocation();
  // const pathname = location.pathname.split("/")[1];

  // const isActive = (path) => pathname === path;

  const handleMouseEnter = (menuName) => {
    // เปิดเมนูที่กำหนด
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    setHoveredMenu(menuName);
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      setHoveredMenu(null); // ปิดเมนูเมื่อออกจากบริเวณ
    }, 200);
  };

  // const toggleMenu = () => {
  //   setIsMenuOpen((prev) => !prev);
  // };

  const dropdownVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.15,
      },
    },
  };

  const navItemVariants = {
    hover: {
      color: "#0F4D81",
      y: -2,
      transition: {
        duration: 0.2,
      },
    },
  };

  const socialIconVariants = {
    hover: {
      scale: 1.1,
      y: -3,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10,
      },
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 600); // เปลี่ยนเลขนี้ตามจุดที่ต้องการให้ Navbar ติดบนสุด
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <motion.div
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={`${
          isScrolled
            ? "fixed top-0 bg-[#5BADD2] w-full py-3 px-12 shadow-md lg:flex justify-between hidden z-50"
            : "bg-[#5BADD2] py-3 px-12 z-50 lg:flex justify-between hidden"
        }`}
      >
        <div className="flex space-x-10 text-gray-200">
          {/* หน้าหลัก */}
          <motion.div
            variants={navItemVariants}
            whileHover="hover"
            onClick={() => navigate("/")}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <span>หน้าหลัก</span>
          </motion.div>

          {/* เกี่ยวกับเรา */}
          <motion.div
            onMouseEnter={() => handleMouseEnter("เกี่ยวกับเรา")}
            onMouseLeave={handleMouseLeave}
            className="flex items-center space-x-2 cursor-pointer relative"
          >
            <motion.span variants={navItemVariants} whileHover="hover">
              เกี่ยวกับเรา
            </motion.span>
            <motion.i
              className="fa-regular fa-circle-down"
              animate={{ rotate: hoveredMenu === "เกี่ยวกับเรา" ? 180 : 0 }}
              transition={{ duration: 0.2 }}
            />

            <AnimatePresence>
              {hoveredMenu === "เกี่ยวกับเรา" && (
                <motion.div
                  variants={dropdownVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-[300px] absolute top-full left-0 bg-[#5BADD2] shadow-lg z-50 rounded-b-md overflow-hidden"
                >
                  <div className="flex flex-col text-white border-t border-gray-300">
                    {menuAbout.map((item) => (
                      <motion.div
                        key={item.id}
                        whileHover={{
                          backgroundColor: "rgba(255,255,255,0.1)",
                        }}
                        onClick={() => {
                          handleMouseLeave();
                          navigate(item.link);
                        }}
                        className={`px-4 py-3 ${
                          item.status ? "block" : "hidden"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          <i className="fa-regular fa-circle-check text-xs"></i>
                          {item.name}
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* บริการของเรา */}
          <motion.div
            onMouseEnter={() => handleMouseEnter("บริการของเรา")}
            onMouseLeave={handleMouseLeave}
            className="flex items-center space-x-2 cursor-pointer relative"
          >
            <motion.span variants={navItemVariants} whileHover="hover">
              บริการของเรา
            </motion.span>
            <motion.i
              className="fa-regular fa-circle-down"
              animate={{ rotate: hoveredMenu === "บริการของเรา" ? 180 : 0 }}
              transition={{ duration: 0.2 }}
            />

            <AnimatePresence>
              {hoveredMenu === "บริการของเรา" && (
                <motion.div
                  variants={dropdownVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-[800px] absolute top-full -left-20 bg-[#5BADD2] shadow-lg z-50 rounded-b-md overflow-hidden p-4"
                >
                  {/* คลินิกพิเศษ */}
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    className="mb-6"
                  >
                    <h3 className="text-xl font-semibold border-b pb-2 mb-3">
                      คลินิกพิเศษ
                    </h3>
                    <div className="grid grid-cols-3 gap-4">
                      {specialClinic.map((item) => (
                        <motion.div
                          key={item.id}
                          whileHover={{ x: 5 }}
                          onClick={() => {
                            handleMouseLeave();
                            navigate(`/clinic/page/${item.id}`);
                          }}
                          className="text-sm hover:text-[#9e76b3] cursor-pointer"
                        >
                          {item.name}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>

                  {/* ศัลยกรรม */}
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.15 }}
                    className="mb-6"
                  >
                    <h3 className="text-xl font-semibold border-b pb-2 mb-3">
                      ศัลยกรรม
                    </h3>
                    <div className="grid grid-cols-3 gap-4">
                      {menuSurgery.map((item) => (
                        <motion.div
                          key={item.id}
                          whileHover={{ x: 5 }}
                          onClick={() => {
                            handleMouseLeave();
                            navigate(`/surgery/page/${item.id}`);
                          }}
                          className="text-sm hover:text-[#9e76b3] cursor-pointer"
                        >
                          {item.name}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>

                  {/* หน่วยทัศนวินิจฉัย */}
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="mb-6"
                  >
                    <h3 className="text-xl font-semibold border-b pb-2 mb-3">
                      หน่วยทัศนวินิจฉัย
                    </h3>
                    <div className="grid grid-cols-3 gap-4">
                      {menuDiagnose.map((item) => (
                        <motion.div
                          key={item.id}
                          whileHover={{ x: 5 }}
                          onClick={() => {
                            handleMouseLeave();
                            navigate(`/center/page/${item.id}`);
                          }}
                          className="text-sm hover:text-[#9e76b3] cursor-pointer"
                        >
                          {item.name}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>

                  {/* อื่นๆ */}
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.25 }}
                  >
                    <h3 className="text-xl font-semibold border-b pb-2 mb-3">
                      อื่นๆ
                    </h3>
                    <div className="grid grid-cols-3 gap-4">
                      {menuOther.map((item) => (
                        <motion.div
                          key={item.id}
                          whileHover={{ x: 5 }}
                          onClick={() => {
                            handleMouseLeave();
                            navigate(`/other/page/${item.id}`);
                          }}
                          className="text-sm hover:text-[#9e76b3] cursor-pointer"
                        >
                          {item.name}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* ข่าวประกาศ */}
          <motion.div
            onMouseEnter={() => handleMouseEnter("ข่าวประกาศ")}
            onMouseLeave={handleMouseLeave}
            className="flex items-center space-x-2 cursor-pointer relative"
          >
            <motion.span variants={navItemVariants} whileHover="hover">
              ข่าวประกาศ
            </motion.span>
            <motion.i
              className="fa-regular fa-circle-down"
              animate={{ rotate: hoveredMenu === "ข่าวประกาศ" ? 180 : 0 }}
              transition={{ duration: 0.2 }}
            />

            <AnimatePresence>
              {hoveredMenu === "ข่าวประกาศ" && (
                <motion.div
                  variants={dropdownVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-[300px] absolute top-full left-0 bg-[#5BADD2] shadow-lg z-50 rounded-b-md overflow-hidden"
                >
                  <div className="flex flex-col text-white border-t border-gray-300">
                    {menuNew.map((item) => (
                      <motion.div
                        key={item.id}
                        whileHover={{
                          backgroundColor: "rgba(255,255,255,0.1)",
                        }}
                        onClick={() => {
                          handleMouseLeave();
                          navigate(`/news/page/${item.id}`);
                        }}
                        className={`px-4 py-3 ${
                          item.status ? "block" : "hidden"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          <i className="fa-regular fa-circle-check text-xs"></i>
                          {item.name}
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* ติดต่อเรา */}
          <motion.div
            onMouseEnter={() => handleMouseEnter("ติดต่อเรา")}
            onMouseLeave={handleMouseLeave}
            className="flex items-center space-x-2 cursor-pointer relative"
          >
            <motion.span variants={navItemVariants} whileHover="hover">
              ติดต่อเรา
            </motion.span>
            <motion.i
              className="fa-regular fa-circle-down"
              animate={{ rotate: hoveredMenu === "ติดต่อเรา" ? 180 : 0 }}
              transition={{ duration: 0.2 }}
            />

            <AnimatePresence>
              {hoveredMenu === "ติดต่อเรา" && (
                <motion.div
                  variants={dropdownVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-[300px] absolute top-full left-0 bg-[#5BADD2] shadow-lg z-50 rounded-b-md overflow-hidden"
                >
                  <div className="flex flex-col text-white border-t border-gray-300">
                    {menuContact.map((item) => (
                      <motion.div
                        key={item.id}
                        whileHover={{
                          backgroundColor: "rgba(255,255,255,0.1)",
                        }}
                        onClick={() => {
                          handleMouseLeave();
                          item.link.startsWith("https://")
                            ? window.open(item.link, "_blank")
                            : navigate(item.link);
                        }}
                        className={`px-4 py-3 ${
                          item.status ? "block" : "hidden"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          <i className="fa-regular fa-circle-check text-xs"></i>
                          {item.name}
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>

        {/* Social Icons */}
        <motion.div
          className="flex justify-center items-center gap-x-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <motion.div
            variants={socialIconVariants}
            whileHover="hover"
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=61558866538285",
                "_blank"
              )
            }
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer shadow-md"
          >
            <i className="fab fa-facebook-f text-[#5BADD2] text-xl"></i>
          </motion.div>

          <motion.div
            variants={socialIconVariants}
            whileHover="hover"
            onClick={() => setShowModal(true)}
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer shadow-md"
          >
            <i className="fab fa-line text-[#5BADD2] text-xl"></i>
          </motion.div>
        </motion.div>
      </motion.div>
      <Modal
        id="default-modal"
        title={"Line official NOVEL CMU"}
        size="max-w-sm"
        linkDownload={""}
        show={showModal}
        onClose={closeModal}
      >
        <div className="flex flex-col justify-center items-center gap-y-5">
          <img
            src="https://qr-official.line.me/gs/M_081ctdmi_BW.png?oat_content=qr"
            alt="Line ID"
          />
          <button
            onClick={() => window.open("https://lin.ee/zFKvapU", "_blank")}
            className="bg-green-500 hover:bg-green-600 w-full transition-all duration-500 ease-linear text-white py-2 px-4 rounded "
          >
            Add Line Official NOVEL CMU
          </button>
        </div>
      </Modal>
    </>
  );
};

export default DropdownMenu;
